module.exports = __webpack_public_path__ + "static/img/Case1_2.8253a9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case5/Case1_2.jpg
// module id = K24Z
// module chunks = 1